import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import { CSSAttribute } from '../../common/types';

interface MPUCreativeProps {
  size: { width: number; height: number };
  tag: string;

  style?: CSSAttribute;
}

export function MPUTagCreative({ size, tag, style = {} }: MPUCreativeProps) {
  const srcDoc = useMemo(() => {
    return `<body style="margin: 0;overflow: hidden;">${decodeURIComponent(tag)}</body>`;
  }, [tag]);

  return (
    <iframe
      srcDoc={srcDoc}
      frameBorder={0}
      style={{
        ...style,
        ...size,
        display: 'block',
        margin: '0 auto',
      }}
    />
  );
}
